import { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {actions, Form} from 'forms/rrf';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import ArrowButton from '../../common/button-arrow';
import RequiredInput from '../../common/form/elements/required-input';

class Reply extends Component {
  componentDidMount() {
    const {dispatch, message: {attributes: {subject}}} = this.props;

    dispatch(actions.change('deep.reply_message.subject', `Re: ${subject}`));
  }

  render() {
    const {
      onCancel, onReply, formValid, message: {attributes: {from}}
    } = this.props;

    return (
      <Row>
        <Col lg={12}>
          <div>
            <Form model="deep.reply_message" onSubmit={onReply}>
              <h5>Reply to {from}</h5>
              <RequiredInput model=".subject" placeholder="Subject" label="Subject"/>
              <RequiredTextarea model=".body" label="Message" rows={5}/>
              <div className="mg-top-20" style={{height: 50}}>
                <ArrowButton
                  color="white"
                  className="float-end"
                  submit
                  arrow={false}
                  disabled={!formValid}
                >
                  Send
                </ArrowButton>

                <ArrowButton
                  color="white"
                  className="float-end"
                  submit={false}
                  arrow={false}
                  disabled={false}
                  onClick={() => onCancel(false)}
                >
                  Cancel
                </ArrowButton>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.reply_message.$form.valid
});

export default connect(mapStateToProps)(Reply);
